/*
 * BeamFlexure Controller. Handles client side modification of the model
 *
 */

function hideResultDisplays() {
    document.getElementById("results-view-div").classList.add('hidden')
    document.getElementById("beam-reactions-div").classList.add('hidden')
    document.getElementById("design-summary-div").classList.add('hidden')
    document.getElementById("plots-div").classList.add('hidden')
    document.getElementById("numerical-results-div").classList.add('hidden')
    document.getElementById('api-error-panel').classList.add('hidden')
}

function autoBeamFlexureDesign() {
    // if logged in and paying customer do auto design
    // else invalidate results and highlight "Calculate" button
    if(customerLevel === "pro") {
        doBeamFlexureDesign()
    } else {
        hideResultDisplays()
    }
}

function BeamController(beam, design) {
    this.beam = beam
    this.design = design
    this.SortAndCompactBraces()
}

function nodeSort(a, b){ return a.x - b.x; }

function CycleSupport(supportIndex) {
    activeProject.beamController.CycleSupport(supportIndex);
    autoBeamFlexureDesign();
}

// a bare bones model. we directly access the model to supress the
// display of "Beam Modified, Save Now?" message
// we also don't call RedrawCanvas here because it gets called later
// we pass in a boolean isLoggedIn allowing us to show new users a more
// complex (engaging?) beam example. 
BeamController.prototype.MakeDefaultBeam = function(isLoggedIn) {
    this.beam.nodes.push(new NodeClass(0, "pinned"));
    this.beam.nodes.push(new NodeClass(144, "pinned"));
    if(!isLoggedIn) {
        this.beam.nodes.push(new NodeClass(288, "pinned"));
    }
    this.beam.nodes.sort( nodeSort );
    this.beam.rebuildSpans();
    this.beam.distLoads.push( new DistLoad( 0, 144, 1000/12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, false) );
    if(!isLoggedIn) {
        this.beam.pointLoads.push( new PointLoad(144 * 1.5, 1000, 0, 0, 0, 0, 0, 0, 0, false ) );
    }
    //sort distributed loads based on length
    this.beam.distLoads.sort( function(a, b){return a.Length() < b.Length(); } );
}

BeamController.prototype.AddNode = function(node) {
    this.beam.nodes.push(new NodeClass(node.x, node.support));
    this.beam.nodes.sort( nodeSort );
    this.beam.rebuildSpans();
    RedrawCanvas();
};

BeamController.prototype.ModifySupport = function( index, support ) {
    if( index >= this.beam.nodes.length || index < 0 ) return alert("Node index out of range.");
    this.beam.nodes[index].support = support;
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.CycleSupport = function( index ) {
    //"free" -> "pinned" -> "fixed" ->
    if( index >= this.beam.nodes.length || index < 0 ) {
        return alert("Node index out of range.")
    }
    var support = this.beam.nodes[index].support;
    if( support == "free" ) this.beam.nodes[index].support = "pinned";
    else if( support == "pinned" ) this.beam.nodes[index].support = "fixed";
    else if( support == "fixed" ) this.beam.nodes[index].support = "free";
    this.CheckStability();
    RedrawCanvas();
    markBeamDesignNeedsSaved();
};

BeamController.prototype.AddRightSpan = function( length ) {
    if(customerLevel !== "pro" && this.beam.nodes.length > 2) {
        alert("Span limit for the free version is 2. Sign up to add more spans.");
        return false;
    }

    if( this.beam.nodes.length > 11 ) {
        alert( "Span limit is 10.");
        return false;
    }
    if( this.beam.TotalLength() + length > 500*12 ) {
        alert( "This beam is way too long!" );
        return false;
    }
    //delete all "connection" braces
    var x = length + this.beam.TotalLength();
    this.beam.nodes.push( new NodeClass( x, "pinned") );
    this.beam.nodes.sort(nodeSort);
    this.beam.rebuildSpans();
    this.CheckStability();
    this.SortAndCompactBraces();
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.AddLeftSpan = function( length ) {
    if(customerLevel !== "pro" && this.beam.nodes.length > 2) {
        alert("Span limit for the free version is 2. Sign up to add more spans.");
        return false;
    }
    if( this.beam.nodes.length > 11 ) {
        alert( "Span limit is 10.");
        return false;
    }
    if( this.beam.TotalLength() + length > 500*12 ) {
        alert( "This beam is way too long!" );
        return false;
    }
    //delete all "connection" braces
    for( var i = 0 ; i < this.beam.nodes.length; i++ ) {
        this.beam.nodes[i].x += length;
    }
    this.beam.nodes.push( new NodeClass( 0, "pinned") );
    this.beam.nodes.sort(nodeSort);
    this.beam.rebuildSpans();
    this.CheckStability();
    this.SortAndCompactBraces();
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.modifySpan = function( index, length ) {
    //get right node of this span and move it and all the following nodes
    var delta = length - this.beam.spans[index].length();
    var original_length = this.beam.TotalLength();
    if( original_length + length > 500*12 ) {
        alert( "This beam is way too long!" );
        return false;
    }
    //delete all "connection" braces
    for( var i = index+1; i < this.beam.nodes.length; i++ ) {
        this.beam.nodes[i].x += delta;
    }
    this.beam.nodes.sort(nodeSort);
    this.beam.rebuildSpans();
    this.ValidateLoads(delta, original_length);
    this.CheckStability();
    this.SortAndCompactBraces();
    RedrawCanvas();
    markBeamDesignNeedsSaved();
};

BeamController.prototype.RemoveSpan = function( index ) {
    if( this.beam.spans.length <= 1 ) return false;
    //remove the node to the right of this span...
    if( this.beam.spans.length < index ) return false;
    var original_length = this.beam.TotalLength();
    var x = this.beam.spans[index].x2;
    var delta = this.beam.spans[index].x2 - this.beam.spans[index].x1;
    var node_index = index+1;
    if( node_index >= this.beam.nodes.length ){
        alert( "node index out of range" );
        return false;
    }
    this.beam.nodes.splice(node_index, 1);
    this.beam.nodes.sort(nodeSort);
    for( var i = node_index; i < this.beam.nodes.length; i++ ) {
        this.beam.nodes[i].x -= delta;
    }
    this.beam.rebuildSpans();

    this.ValidateLoads(delta, original_length);
    this.CheckStability();
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.AddPointLoad = function( x, D, L, Lr, S, W, E, H, R, isMoment ) {
    if( this.beam.pointLoads.length > 20 ) {
        alert( "Load limit is 20.");
        return false;
    }
    if( x > this.beam.TotalLength() ) { x = this.beam.TotalLength(); }
    if( x < 0 ) { x = 0; }
    this.beam.pointLoads.push( new PointLoad( x, D, L, Lr, S, W, E, H, R, isMoment ) );
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.ModifyPointLoad = function( index, x, D, L, Lr, S, W, E, H, R ) {
    if( index >= this.beam.pointLoads.length || index < 0 ) return alert("Point Load index out of range.");
    if( x > this.beam.TotalLength() ) x = this.beam.TotalLength();
    if( x < 0 ) x = 0;
    this.beam.pointLoads[index].x = x;
    this.beam.pointLoads[index].D = D;
    this.beam.pointLoads[index].L = L;
    this.beam.pointLoads[index].Lr = Lr;
    this.beam.pointLoads[index].S = S;
    this.beam.pointLoads[index].W = W;
    this.beam.pointLoads[index].E = E;
    this.beam.pointLoads[index].H = H;
    this.beam.pointLoads[index].R = R;
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.RemovePointLoad = function( index ) {
    if( index >= this.beam.pointLoads.length || index < 0 ) return alert("Point Load index out of range.");
    this.beam.pointLoads.splice(index, 1 );
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.AddDistLoad = function(start, end, D, L, Lr, S, W, E, H, R, D2, L2, Lr2, S2, W2, E2, H2, R2, isLinear) {
    if( this.beam.distLoads.length > 10 )
    {
        alert( "Distributed Load limit is 10.");
        return false;
    }
    if( start > this.beam.TotalLength() ) return alert( "Dist. Load does not lie on beam.");
    if( start < 0 ) return alert( "Dist. Load can't be negative." );
    if( end > this.beam.TotalLength() ) return alert( "Dist. Load does not lie on beam.");
    if( end < 0 ) return alert( "Dist. Load can't be negative." );
    this.beam.distLoads.push( new DistLoad( start, end, D, L, Lr, S, W, E, H, R, D2, L2, Lr2, S2, W2, E2, H2, R2, isLinear) );
    //sort distributed loads based on length
    this.beam.distLoads.sort( function(a, b){return a.Length() < b.Length(); } );
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.ModifyDistLoad = function( index, start, end, D, L, Lr, S, W, E, H, R, D2, L2, Lr2, S2, W2, E2, H2, R2, isLinear ) {
    if( index >= this.beam.distLoads.length || index < 0 ) return alert("Dist. Load index out of range.");
    if( start > this.beam.TotalLength() ) return alert( "Dist. Load does not lie on beam.");
    if( start < 0 ) return alert( "Dist. Load can't be negative." );
    if( end > this.beam.TotalLength() ) return alert( "Dist. Load does not lie on beam.");
    if( end < 0 ) return alert( "Dist. Load can't be negative." );
    this.beam.distLoads[index].x1 = start;
    this.beam.distLoads[index].x2 = end;
    this.beam.distLoads[index].D = D;
    this.beam.distLoads[index].L = L;
    this.beam.distLoads[index].Lr = Lr;
    this.beam.distLoads[index].S = S;
    this.beam.distLoads[index].W = W;
    this.beam.distLoads[index].E = E;
    this.beam.distLoads[index].H = H;
    this.beam.distLoads[index].R = R;
    this.beam.distLoads[index].isLinear = isLinear;
    this.beam.distLoads[index].D2 = D2;
    this.beam.distLoads[index].L2 = L2;
    this.beam.distLoads[index].Lr2 = Lr2;
    this.beam.distLoads[index].S2 = S2;
    this.beam.distLoads[index].W2 = W2;
    this.beam.distLoads[index].E2 = E2;
    this.beam.distLoads[index].H2 = H2;
    this.beam.distLoads[index].R2 = R2;
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.RemoveDistLoad = function( index ) {
    if( index >= this.beam.distLoads.length || index < 0 ) return alert("Distributed Load index out of range.");
    this.beam.distLoads.splice(index, 1 );
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.ValidateLoads = function( delta, original_length ) {
    //make sure loads are not off the edge of the beam
    var totalLength = this.beam.TotalLength(), i;
    for( i = 0; i < this.beam.pointLoads.length; i++ ) {
        //if load was at right edge, keep it "snapped" to the right edge
        if( this.beam.pointLoads[i].x == original_length ) this.beam.pointLoads[i].x = totalLength;
        if( this.beam.pointLoads[i].x > totalLength ) this.beam.pointLoads[i].x += delta;
        if( this.beam.pointLoads[i].x < 0 ) this.beam.pointLoads[i].x = 0;
        if( this.beam.pointLoads[i].x > totalLength ) this.beam.pointLoads[i].x = totalLength;

    }
    for( i = 0; i < this.beam.distLoads.length; i++ )
    {
        //if load was at right edge, keep it "snapped" to the right edge
        if( this.beam.distLoads[i].x2 == original_length ) this.beam.distLoads[i].x2 = totalLength;
        if( this.beam.distLoads[i].x2 > totalLength ){
            this.beam.distLoads[i].x1 += delta;
            this.beam.distLoads[i].x2 += delta;
        }
        if( this.beam.distLoads[i].x1 < 0 ) this.beam.distLoads[i].x1 = 0;
        if( this.beam.distLoads[i].x2 > totalLength ) this.beam.distLoads[i].x2 = totalLength;
    }
};

BeamController.prototype.CheckStability = function() {
    //1. at least 1 fixed support
    //2. 1 pin and 1 roller
    //3. 2 pins
    //4. 2 pins
    var stable = false;
    var roller_or_pin_count = 0;
    for( var i = 0; i < this.beam.nodes.length; i++ )
    {
        if( this.beam.nodes[i].support == "fixed"){
            stable = true;
            break;
        }
        if( this.beam.nodes[i].support == "pinned" ||
           this.beam.nodes[i].support == "roller"){
            roller_or_pin_count++;
            if( roller_or_pin_count > 1 ){
                stable = true;
                break;
            }
        }
    }
    //update solve button...
    if( stable ){
        document.getElementById('design-this-beam-text').removeAttribute('disabled')
        document.getElementById('design-this-beam-text').innerHTML = ' Calculate'
        return true;
    } else {
        document.getElementById('design-this-beam-text').setAttribute('disabled', true)
        document.getElementById('design-this-beam-text').innerHTML = ' Beam is Not Stable - Add Another Support'
        return false;
    }
};

BeamController.prototype.updateBracingType = function(bracingType) {
    this.design.bracingType = bracingType;
    this.SortAndCompactBraces();
    markBeamDesignNeedsSaved();
    RedrawCanvas();
};

BeamController.prototype.isEquallySpacedBracing = function() {
    return this.design.bracingType === "equal"
};

BeamController.prototype.addBrace = function(brace, isSupport) {
    if( brace > this.beam.TotalLength() ) return false;
    this.design.customBraces.push(new BeamBrace(brace, isSupport));
    this.SortAndCompactBraces();
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.removeBrace = function(index) {
    if( index >= this.design.customBraces.length || index < 0 ) return false;
    this.design.customBraces.splice(index,1);
    this.SortAndCompactBraces();
    RedrawCanvas();
    markBeamDesignNeedsSaved();
    return true;
};

BeamController.prototype.addEquallySpacedBraces = function(spacing, startingAt) {
    if( spacing > this.beam.TotalLength() || spacing <= 0) return false
    if( startingAt > this.beam.TotalLength()) return false
    //check we're not adding more than about 50
    const nBraces = (parseFloat(this.beam.TotalLength()) - parseFloat(startingAt)) / Number(spacing)
    if(nBraces > 50) return false
    this.design.bracingStartLocation = startingAt
    this.design.braceSpacing = spacing
    
    this.design.customBraces = []
    for( var i = 0; i <= nBraces; i++ ) {
        const loc = i * spacing + startingAt
        if( loc <= this.beam.TotalLength() ) {
            this.design.customBraces.push(new BeamBrace(loc, false))
        }
    }
    this.SortAndCompactBraces()
    RedrawCanvas()
    markBeamDesignNeedsSaved()
    return true;
};

BeamController.prototype.sortAndRemoveDuplicateBraces = function() {
    if(this.design.customBraces.length < 2) { return } 
    this.design.customBraces.sort(function(a, b){ return a.x - b.x })
    const braces = [];
    braces.push(this.design.customBraces[0])
    for (let i = 1; i < this.design.customBraces.length; i++) {
        if (this.design.customBraces[i - 1].x !== this.design.customBraces[i].x) {
            braces.push(new BeamBrace(this.design.customBraces[i].x, this.design.customBraces[i].isSupport))
        }
    }
    this.design.customBraces = []
    this.design.customBraces = braces;
}

BeamController.prototype.SortAndCompactBraces = function() {
    this.sortAndRemoveDuplicateBraces()
    for(let i = 0; i < this.beam.nodes.length; i++ ) {
        if(this.beam.nodes[i].support.match(/free/)) { continue }
        let exists = false
        for(let j = 0; j < this.design.customBraces.length; j++){
            if(this.beam.nodes[i].x === this.design.customBraces[j].x) {
                exists = true
                this.design.customBraces[j].isSupport = true
                break
            }
        }
        if(exists === false) {
            this.design.customBraces.push(new BeamBrace(this.beam.nodes[i].x, true))
        }
    }
    this.sortAndRemoveDuplicateBraces()
};

BeamController.prototype.UpdateNumberOfPlys = function(numberOfPlys) {
    if(numberOfPlys < 1) { alert("Number of plys must be greater than 0."); }
    activeProject.numberOfPlys = numberOfPlys;
    markBeamDesignNeedsSaved();
    RedrawCanvas();
}

/*
 * Send Client Beam Model and Design Settings to the server
 *
 * Steel design only, for now.
 *
 */
function doBeamFlexureDesign() {
    if (!activeProject.beamController.CheckStability()) {
        return;
    }

    hideResultDisplays()

    const projectDict = activeProject.projectForAnalysis

    document.getElementById('design-this-beam-button').disabled = true
    document.getElementById('calculate-wait-spinner').classList.remove('hidden')

    const designUrl = '/api/v1/beam-flexure/new-solver/design/';
    
    ga('send', 'event', 'Analysis', 'design requested', 'Customer started a design');
    ga('send', 'event', 'Analysis', activeProject.designTypeStr, 'Analysis and design succeeded');

    const url = designUrl
    fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(projectDict),
    })
    .then(response => response.json())
    .then( (data) => {
        showNumericalResults(data);
        showResultCharts(data);
        showDesignCheckSummary(data);
        document.getElementById('design-this-beam-button').disabled = false
        document.getElementById('calculate-wait-spinner').classList.add('hidden')

        ga('send', 'event', 'Analysis', 'design succeeded', 'Analysis and design succeeded');
    })
    .catch((error) => {
        document.getElementById('calculate-wait-spinner').classList.add('hidden')
        document.getElementById('api-error-div').classList.remove('hidden')
        const showDebugInfo = false;
        if( showDebugInfo ) {
            document.getElementById('api-error-panel').innerHTML = error
        }
        document.getElementById('design-this-beam-button').disabled = false
        g_results = [];
        ga('send', 'event', 'Analysis', 'design failed', 'Analysis and design failed');
    })
}
